import { Controller } from "@hotwired/stimulus"
import * as Routes from "routes"

export default class extends Controller {
  static targets = ["callout"]

  dismiss() {
    if (this.hasCalloutTarget) this.calloutTarget.remove()

    fetch(Routes.ispm_nav_tooltip_dismissed_account_path(), {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content }
    })
  }
}
